import { AppRouteProps } from "@bsm/component";
import { SchoolHolidayRoutes } from "./views/school-holiday/SchoolHolidayRoutes";
import { HolidayGroupViewerContainer } from "./container/HolidayGroupViewerContainer";
import { PublicHolidayRoutes } from "./views/public-holiday/PublicHolidayRoutes";
 
export const HolidayViewerRoutes: Array<AppRouteProps> = [
    {
        path: "viewer",
        title: "std_calendar",
        element: <HolidayGroupViewerContainer />,
        children: [
            ...SchoolHolidayRoutes,
            ...PublicHolidayRoutes
        ]
    },
];